import { constants } from '@config';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  changeBrochureType: function (opts) {
    INKIVE.C.PRINTING_TYPE.print_type = opts.type;
    this.editor.canvas.runExtensions('zoomChanged');
  },

  setStationaryItemMode: async function () {
    const root = document.querySelector('#svgcanvas');
    const canvasBackground = document.querySelector('#canvasBackground');

    canvasBackground.querySelector('.background').setAttribute('fill', 'transparent');
    svgedit.utilities.assignAttributes(canvasBackground.querySelector('.background'), {
      'stroke-dasharray': 12,
      stroke: constants.colors.mugGuideline,
      'stroke-width': 6
    });

    root.style.backgroundRepeat = 'no-repeat';
    root.style.backgroundSize = 'no-repeat';
    root.style.backgroundPosition = 'center center';

    this.setBackgroundImage();
  },

  setBackgroundImage: function () {
    const root = document.querySelector('#svgcanvas');
    const printType = INKIVE.Helpers.getPrintGuidelinesProject();
    const background = constants.printingTypes[printType].img[INKIVE.Tool._current_page_number || 1];

    INKIVE.EditorFacade.once('page.move_to', () => this.setBackgroundImage());
    root.style.backgroundImage = `url(${background.url})`;
  }
}, Backbone.Events);
